module.exports = __webpack_public_path__ + "img/email1.f2e4f88c.png";